import Config from '@config';
import { createApi } from '@reduxjs/toolkit/query/react';

import { Role } from '@/features/counterpartyUsers/types';
import axiosBaseQuery from '@/utils/axiosBaseQuery';

export const rolesApi = createApi({
  reducerPath: 'rolesApi',
  baseQuery: axiosBaseQuery({
    baseUrl: Config.VITE_API_URL + '/roles',
  }),
  tagTypes: ['Roles'],
  endpoints: builder => ({
    getRoles: builder.query<Role[], void>({
      query: () => ({
        url: '',
      }),
      providesTags: ['Roles'],
    }),
  }),
});

export const { useGetRolesQuery } = rolesApi;
